import React from "react";
import { FaChartPie, FaGaugeHigh, FaMagnifyingGlassChart } from "react-icons/fa6";
import energy from "../assets/banner1.jpg";

export default function EnergyManagement() {
  const features = [
    {
      icon: <FaMagnifyingGlassChart size={20} className="text-primary" />,
      text: "Visibility into digital operations through better information structure and reporting clarity.",
    },
    {
      icon: <FaChartPie size={20} className="text-primary" />,
      text: "Analytics-oriented thinking that helps organizations turn activity into usable insight.",
    },
    {
      icon: <FaGaugeHigh size={20} className="text-primary" />,
      text: "Performance-focused improvement across systems, service delivery, and decision support.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Extended Capability</div>
          <h2 className="main-section-title">Data, Analytics & Performance Insights</h2>
          <p className="section-copy">
            Nova Technologies helps organizations strengthen decision-making through clearer
            digital visibility and performance-oriented insight.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={energy} alt="Data, Analytics and Performance Insights" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Better decisions depend on clearer information. This capability area supports
            organizations that want stronger reporting, improved visibility, and digital
            tools that make operational performance easier to understand and improve.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Review reporting needs and decision-making priorities.</li>
            <li>Identify gaps in information flow, visibility, and measurement.</li>
            <li>Design practical analytics and performance-support improvements.</li>
            <li>Refine the insight model as organizational needs evolve.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
